import { render, staticRenderFns } from "./ResourceLocation.vue?vue&type=template&id=6c2e74f0"
import script from "./ResourceLocation.vue?vue&type=script&lang=ts"
export * from "./ResourceLocation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports